// Angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Actions, ofType } from '@ngrx/effects';
// NGRX
import { select, Store } from '@ngrx/store';
// RxJS
import { Observable, Subject, Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import {
  LayoutUtilsService,
  MessageType,
} from '../../../../../../core/_base/crud';
// AppState
import { AppState } from '../../../../../../core/reducers';
import {
  GCActionFail,
  GCActionSuccess,
  GConfig,
  GConfigActionTypes,
  GConfigBulkUpdate,
  selectGConfigById,
} from '../../../../../../core/rex';

@Component({
  selector: 'kt-taxydema',
  templateUrl: './taxydema.component.html',
  styleUrls: ['./taxydema.component.scss'],
})
export class TaxydemaComponent implements OnInit, OnDestroy {
  @Input() saveEvent: Observable<void>;

  txy_api_endpoint: GConfig = new GConfig();
  txy_account_code: GConfig = new GConfig();
  txy_user_alias: GConfig = new GConfig();
  txy_credential_value: GConfig = new GConfig();
  txy_api_key: GConfig = new GConfig();

  hasFormErrors = false;
  serverError: Subject<any>;
  txyForm: UntypedFormGroup;
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store<AppState>,
    private layoutUtilsService: LayoutUtilsService,
    private actions$: Actions,
    private txyFB: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.serverError = new Subject();
    this.serverError.next(false);

    const ss = this.saveEvent.subscribe(() => this.save());
    this.subscriptions.push(ss);

    this.fetchDataFromStore();
    this.createForm();

    const sss = this.actions$
      .pipe(
        ofType<GCActionSuccess>(GConfigActionTypes.GCActionSuccess),
        tap(({ payload }) => {
          this.layoutUtilsService.showActionNotification(
            payload.result,
            MessageType.Update,
            5000,
            true,
            true
          );
        })
      )
      .subscribe();
    this.subscriptions.push(sss);

    const sf = this.actions$
      .pipe(
        ofType<GCActionFail>(GConfigActionTypes.GCActionFail),
        tap(({ payload }) => {
          if (
            // eslint-disable-next-line no-prototype-builtins
            payload.result.hasOwnProperty('error') &&
            // eslint-disable-next-line no-prototype-builtins
            payload.result.error.hasOwnProperty('detail')
          ) {
            this.serverError.next(payload.result.error.detail);
          } else {
            this.serverError.next(
              'Συνέβη ένα σφάλμα με την αποθήκευση των δεδομένων. Παρακαλώ ξαναπροσπαθήστε.'
            );
          }
        })
      )
      .subscribe();
    this.subscriptions.push(sf);
  }

  fetchDataFromStore() {
    this.store
      .pipe(
        select(selectGConfigById('hidden__TXY_API_ENDPOINT')),
        take(1),

        tap(res => (this.txy_api_endpoint = { ...res }))
      )
      .subscribe();

    this.store
      .pipe(
        select(selectGConfigById('hidden__TXY_ACCOUNT_CODE')),
        take(1),
        tap(res => (this.txy_account_code = { ...res }))
      )
      .subscribe();

    this.store
      .pipe(
        select(selectGConfigById('hidden__TXY_USER_ALIAS')),
        take(1),
        tap(res => (this.txy_user_alias = { ...res }))
      )
      .subscribe();

    this.store
      .pipe(
        select(selectGConfigById('hidden__TXY_CREDENTIAL_VALUE')),
        take(1),
        tap(res => (this.txy_credential_value = { ...res }))
      )
      .subscribe();

    this.store
      .pipe(
        select(selectGConfigById('hidden__TXY_API_KEY')),
        take(1),
        tap(res => (this.txy_api_key = { ...res }))
      )
      .subscribe();
  }

  createForm() {
    const fgd: { [k: string]: any } = {
      txy_api_endpoint: [this.txy_api_endpoint.value, Validators.required],
      txy_account_code: [this.txy_account_code.value, Validators.required],
      txy_user_alias: [this.txy_user_alias.value, Validators.required],
      txy_credential_value: [
        this.txy_credential_value.value,
        Validators.required,
      ],
      txy_api_key: [this.txy_api_key.value, Validators.required],
    };

    this.txyForm = this.txyFB.group(fgd);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  save() {
    this.hasFormErrors = false;
    this.serverError.next(false);

    const controls = this.txyForm.controls;
    if (this.txyForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );

      this.hasFormErrors = true;
      return;
    }

    this.txy_api_endpoint.value = controls.txy_api_endpoint.value;
    this.txy_account_code.value = controls.txy_account_code.value;
    this.txy_user_alias.value = controls.txy_user_alias.value;
    this.txy_credential_value.value = controls.txy_credential_value.value;
    this.txy_api_key.value = controls.txy_api_key.value;

    const buo: { [key: string]: any } = {};
    buo[this.txy_api_endpoint.identifier] = this.txy_api_endpoint.value;
    buo[this.txy_account_code.identifier] = this.txy_account_code.value;
    buo[this.txy_user_alias.identifier] = this.txy_user_alias.value;
    buo[this.txy_credential_value.identifier] = this.txy_credential_value.value;
    buo[this.txy_api_key.identifier] = this.txy_api_key.value;

    this.store.dispatch(new GConfigBulkUpdate({ values: buo }));
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onAlertClose($event) {
    this.hasFormErrors = false;
    this.serverError.next(false);
  }
}
